<template>
  <div class="height-100-p">
    <el-table
      :data="extensionRequest.list"
      id="extension-data-list"
      size="mini"
      tooltip-effect="dark"
      sortable
      class="dark-blue-table"
      :empty-text="$t('common.notAbleToFindRecords')"
      @sort-change="handleSortChange(data)"
      v-loading="extensionRequest.loadingSearch"
      stripe
    >
      <el-table-column
        prop="number"
        :label="$t('extensionRequest.extensionHash')"
        width="150px"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="shipperNameAndAccount"
        :label="$t('extensionRequest.shipperNameAndAccount')"
        :min-width="10"
        align="left"
        header-align="center"
      >
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="`${scope.row.shipperAccountName} - ${scope.row.shipperAccountNumber}`" placement="top">
            <span>{{ scope.row.shipperAccountName }} - {{ scope.row.shipperAccountNumber }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="shippingHour"
        :label="$t('extensionRequest.extensionTime')"
        :min-width="5"
      ></el-table-column>
      <el-table-column prop="numberUnits" :label="$t('extensionRequest.units')" :min-width="5"></el-table-column>
      <el-table-column
        prop="contactNumber"
        :label="$t('extensionRequest.shipperContact')"
        :min-width="8"
      ></el-table-column>
      <div class="request-Date">
        <el-table-column
          prop="shipDate"
          :label="$t('extensionRequest.receivingDate')"
          :min-width="8"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.shipDate | moment("MM/DD/YYYY") }}</span>
          </template>
        </el-table-column>
      </div>
      <el-table-column prop="status" :label="$t('extensionRequest.status')" :min-width="8">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="`${extensionStatus[scope.row.status].name}`"
            placement="top-start"
          >
            <i class="far fa-clock" :class="extensionStatus[scope.row.status].colorCssClass"></i>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="options" :label="$t('extensionRequest.options ')" :min-width="4">
        <template slot-scope="scope">
          <details-dialog
            :extensionNo="scope.row.number"
            :shipDate="scope.row.shipDate|moment('MM/DD/YYYY')"
          />
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-footer" v-show="extensionRequest.total > 0">
      <span class="el-pagination__total" slot>
        <span class="el-pagination__title" slot>{{ $t('extensionRequest.totalExtensions') }}</span>
        {{ extensionRequest.total }}
      </span>
      <el-pagination
        @size-change="handleSearchChangeLimit"
        :page-sizes="sizes"
        :page-size="extensionRequest.actualFilters.rows"
        :current-page.sync="extensionRequest.actualFilters.page"
        @current-change="handleSearchChangePage"
        :total="extensionRequest.total"
        layout="slot, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';
import DetailsDialog from './components/DetailsDialog';

export default {
  name: 'SearchSummary',
  components: {
    DetailsDialog
  },
  computed: {
    ...mapGetters(['extensionRequest'])
  },
  data() {
    return {
      extensionStatus: constants.ORDER_ENTRY.EXTENSION.STATUS,
      sizes: constants.TABLES.DEFAULT_LIMIT_SIZES
    };
  },
  methods: {
    handleSortChange(data) {
      let { prop } = data;
      const { order } = data;
      prop = constants.TABLES.EXTENSION_REQUEST.COLUMNS_MAP_SORT[prop] || prop;
      this.$store.dispatch('extensionRequest/search', {
        orderField: prop,
        orderDirection: constants.TABLES.ORDER_DIRECTION[order]
      });
    },
    handleSearchChangePage(val) {
      this.$store.dispatch('extensionRequest/search', { page: val });
    },
    handleSearchChangeLimit(val) {
      this.$store.dispatch('extensionRequest/search', {
        rows: val,
        page: constants.TABLES.DEFAULT_PAGE
      });
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.search-summary {
  padding: 15px;
}
.el-table__header {
  th {
    text-align: center;
  }
}
.is-scrolling-none {
  td {
    text-align: center;
    .cell {
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      .clockimg {
        height: 15px;
        img {
          height: 15px;
          width: 15px;
        }
      }
    }
  }
}
#height-100-p {
  .request-Date {
    font-weight: 600;
  }
}
@media only screen and (min-width: 1680px) {
  #height-100-p {
    .consignee-filter {
      width: 725px;
      .el-form-item__content {
        width: 80%;
      }
    }
  }
}
</style>
